import React, { FC, useState } from 'react';
import { Modal } from 'antd';
import styles from './cancelFormModal.module.scss';
import COButton from 'shared/components/COButton';
import { ReactComponent as CloseIcon } from 'assets/icons/close_form.svg';
import { ButtonLabels, ModalProps } from 'enums/CancelFormModal';
import { ReactComponent as CloseModalIcon } from 'assets/icons/close.svg';
import clsx from 'clsx';

interface CancelFormModalProps {
  showModalState: boolean;
  handleModalCancel: () => void;
  handleModalConfirm: () => void;
  onModalCancel?: () => void;
  heading?: string;
  subHeading?: string;
}

const CancelFormModal: FC<CancelFormModalProps> = ({
  showModalState,
  handleModalCancel,
  handleModalConfirm,
  heading,
  subHeading,
  onModalCancel,
}: CancelFormModalProps) => {
  const [buttonLoading, setButtonLoading] = useState(false);

  const submitForm = async () => {
    setButtonLoading(true);
    await handleModalConfirm();
    setButtonLoading(false);
  };

  return (
    <div className={styles.cancelFormModal}>
      <Modal
        width={430}
        zIndex={10001}
        footer={[
          <div className={clsx(styles.formButtonContainer, styles.paddingLeft)}>
            <COButton onClick={submitForm} loading={buttonLoading} cancelForm>
              {ButtonLabels.CLOSE}
            </COButton>
          </div>,
          <div
            className={clsx(styles.formButtonContainer, styles.paddingRight)}>
            <COButton secondary block onClick={handleModalCancel}>
              {ButtonLabels.BACK}
            </COButton>
          </div>,
        ]}
        closeIcon={<CloseModalIcon />}
        maskClosable={false}
        okText={ModalProps.CONFIRM_TEXT}
        open={showModalState}
        wrapClassName={styles.cancelFormModalContainer}
        onOk={handleModalConfirm}
        onCancel={onModalCancel ? onModalCancel : handleModalCancel}>
        {<CloseIcon />}

        <h2 className={styles.cancelFormHeading}>{heading}</h2>

        <p className={styles.cancelFormSubTitle}>{subHeading}</p>
      </Modal>
    </div>
  );
};

export default CancelFormModal;
